module.exports = __webpack_public_path__ + "static/media/icon-cat.3e97031f.svg";